import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const vitalsApi = baseApi.injectEndpoints({
   tagTypes: ["Immunizations"],
   endpoints: (builder) => ({
      getVitals: builder.query({
         query: (params) => {
            return {
               url: `/vitals.json`,
               method: "GET",
               params: params,
            };
         },
         transformResponse: (response, meta, arg) => {
            return parseResponse(response);
         },
      }),
   }),
});

// Export hooks for usage in functional components
export const { useGetVitalsQuery } = vitalsApi;
